const horizontalLoop = (items, config) => {
  items = gsap.utils.toArray(items);
  config = config || {};

  const length = items.length;
  const startX = items[0].offsetLeft;
  const times = [];
  const widths = [];
  const xPercents = [];
  const pixelsPerSecond = (config.speed || 1) * 100;
  const snap = config.snap === false ? (v) => v : gsap.utils.snap(config.snap || 1);

  const tl = gsap.timeline({
    repeat: config.repeat,
    paused: config.paused,
    defaults: { ease: 'none' },
    onReverseComplete: () => tl.totalTime(tl.rawTime() + tl.duration() * 100)
  });

  let curIndex = 0;

  gsap.set(items, {
    xPercent: (i, el) => {
      const w = (widths[i] = parseFloat(gsap.getProperty(el, 'width', 'px')));
      xPercents[i] = snap(
        (parseFloat(gsap.getProperty(el, 'x', 'px')) / w) * 100 + gsap.getProperty(el, 'xPercent')
      );
      return xPercents[i];
    }
  });
  gsap.set(items, { x: 0 });

  const totalWidth =
    items[length - 1].offsetLeft +
    (xPercents[length - 1] / 100) * widths[length - 1] -
    startX +
    items[length - 1].offsetWidth * gsap.getProperty(items[length - 1], 'scaleX') +
    (parseFloat(config.paddingRight) || 0);

  for (let i = 0; i < length; i++) {
    const item = items[i];
    const curX = (xPercents[i] / 100) * widths[i];
    const distanceToStart = item.offsetLeft + curX - startX;
    const distanceToLoop = distanceToStart + widths[i] * gsap.getProperty(item, 'scaleX');

    tl.to(
      item,
      {
        xPercent: snap(((curX - distanceToLoop) / widths[i]) * 100),
        duration: distanceToLoop / pixelsPerSecond
      },
      0
    )
      .fromTo(
        item,
        { xPercent: snap(((curX - distanceToLoop + totalWidth) / widths[i]) * 100) },
        {
          xPercent: xPercents[i],
          duration: (curX - distanceToLoop + totalWidth - curX) / pixelsPerSecond,
          immediateRender: false
        },
        distanceToLoop / pixelsPerSecond
      )
      .add('label' + i, distanceToStart / pixelsPerSecond);
    times[i] = distanceToStart / pixelsPerSecond;
  }

  const toIndex = (index, vars) => {
    vars = vars || {};
    if (Math.abs(index - curIndex) > length / 2) {
      index += index > curIndex ? -length : length;
    }
    const newIndex = gsap.utils.wrap(0, length, index);
    let time = times[newIndex];
    if (time > tl.time() !== index > curIndex) {
      vars.modifiers = { time: gsap.utils.wrap(0, tl.duration()) };
      time += tl.duration() * (index > curIndex ? 1 : -1);
    }
    curIndex = newIndex;
    vars.overwrite = true;
    return tl.tweenTo(time, vars);
  };

  tl.next = (vars) => toIndex(curIndex + 1, vars);
  tl.previous = (vars) => toIndex(curIndex - 1, vars);
  tl.current = () => curIndex;
  tl.toIndex = (index, vars) => toIndex(index, vars);
  tl.times = times;
  tl.progress(1, true).progress(0, true);
  if (config.reversed) {
    tl.vars.onReverseComplete();
    tl.reverse();
  }
  return tl;
};

if (!customElements.get('announcement-marquee')) {
  customElements.define(
    'announcement-marquee',
    class AnnouncementMarquee extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.announcement-bar__track');
        this.speed = (parseInt(this.dataset.speed, 10) || 60) / 100;
        this.pauseOnHover = this.dataset.paused === 'true';
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.designMode = window.Shopify && window.Shopify.designMode;

        if (this.reduceMotion || this.designMode) return;

        this.init();

        this.resizeObserver = new ResizeObserver(() => this.rebuild());
        this.resizeObserver.observe(this);
      }

      disconnectedCallback() {
        if (this.loop) this.loop.kill();
        if (this.resizeObserver) this.resizeObserver.disconnect();
      }

      init() {
        if (typeof gsap === 'undefined') return;

        if (!this.originalItems) {
          this.originalItems = Array.from(this.track.children).map((el) => el.cloneNode(true));
        }

        this.track.innerHTML = '';
        this.originalItems.forEach((el) => this.track.appendChild(el.cloneNode(true)));

        const containerWidth = this.getBoundingClientRect().width;
        let guard = 0;
        while (this.track.scrollWidth < containerWidth * 2 && guard < 20) {
          this.originalItems.forEach((el) => {
            const clone = el.cloneNode(true);
            clone.removeAttribute('id');
            clone.setAttribute('aria-hidden', 'true');
            clone.querySelectorAll('a').forEach((a) => a.setAttribute('tabindex', '-1'));
            this.track.appendChild(clone);
          });
          guard++;
        }

        const items = Array.from(this.track.children);

        this.loop = horizontalLoop(items, {
          repeat: -1,
          speed: this.speed,
          paddingRight: 0
        });

        if (this.pauseOnHover) {
          this.addEventListener('mouseenter', () => this.loop && this.loop.pause());
          this.addEventListener('mouseleave', () => this.loop && this.loop.resume());
          this.addEventListener('focusin', () => this.loop && this.loop.pause());
          this.addEventListener('focusout', () => this.loop && this.loop.resume());
        }
      }

      rebuild() {
        if (this.loop) this.loop.kill();
        this.init();
      }
    }
  );
}